import styles from './InfoCards.module.css';
import { TelegramIcon, WhatsAppIcon } from '../../../../components/Other/Icons/Icons';

const InfoCards = () => {
    return (
        <section className={styles.info_cards}>
            <div className={styles.container}>
                <div className={styles.cardHeader}>
                    <div className={styles.cardHeaderTitle}>
                        <h2>Как с нами <br />связаться</h2>
                    </div>
                    <div className={styles.line}></div>
                    <div className={styles.cardInfo}>
                        <div className={styles.cardInfoItem}>
                            <p>Работаем с 9:00 до 18:00 Пн-Пт</p>
                        </div>
                        <div className={styles.cardInfoItem}>
                            <p>Россия (звонок бесплатный):</p>
                            <span>+ 7 (495) 946-98-68</span>
                        </div>
                    </div>
                </div>
                <div className={styles.social}>
                    <div className={styles.cardInfoItem}>
                        <p>Мы в мессенджерах:</p>
                        <div className={styles.socialLinks}>
                            <a href="https://t.me/yourcompany" target="_blank" rel="noopener noreferrer" className={`${styles.socialLink} ${styles.telegramLink}`}>
                                <TelegramIcon color="var(--color-accent-dark)" size={30} />
                            </a>
                            <a href="https://wa.me/79999999999" target="_blank" rel="noopener noreferrer" className={`${styles.socialLink} ${styles.whatsappLink}`}>
                                <WhatsAppIcon color="var(--color-accent-dark)" size={30} />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.container + ' ' + styles.darkAcceent}>
                <div className={styles.cardHeader}>
                    <div className={styles.cardHeaderTitle}>
                        <h2>Юридический<br />адрес</h2>
                    </div>
                    <div className={styles.line}></div>
                    <div className={styles.cardInfo}>
                        <div className={styles.cardInfoItem}>
                            <p>Адрес:</p>
                            <span>г. Москва, ул. Горбунова, д. 12, корп. 2</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.container + ' ' + styles.bgImage}>
                {/* <div className={styles.cardtitles}> */}
                    <p>Комплексный подход к решению всех Ваших задач "Под ключ"</p>
                    <p>Остаемся всегда с Вами на расстоянии звонка</p>
                    <p>Ответим на все вопросы, даже после оказания услуг и выполнения работ</p>
                {/* </div> */}
            </div>
        </section>
    )
}

export default InfoCards;